import config from "../config/config";

let messageSocket = null;

export function handleMessage(socket, onMessageEvent) {
  socket.onmessage = (event) => {
    // console.log("WebSocket message received", event.data);
    try {
      const { event: eventType, data: msg } = JSON.parse(event.data);
      onMessageEvent(eventType, msg);
    } catch (err) {
      console.error("Failed to parse WebSocket message", err, event.data);
    }
  };
}

export function connectMessageSocket(onMessageEvent) {
  if (messageSocket) {
    console.warn("ChatMessageSocket already connected");
    return;
  }

  messageSocket = new WebSocket(config.MESSAGE_SOCKET_URL);

  messageSocket.onopen = () => {
    console.log("Connected to message WebSocket server successfully");
  };

  handleMessage(messageSocket, onMessageEvent);

  messageSocket.onerror = (err) => {
    console.error("ChatMessage WebSocket error", err);
  };

  messageSocket.onclose = () => {
    console.log("Message WebSocket disconnected");
    messageSocket = null;
  };
}

export function disconnectMessageSocket() {
  if (messageSocket) {
    messageSocket.close();
    messageSocket = null;
  }
}
